var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3603 8.03499C15.3603 10.6788 13.1068 12.7974 10.2947 12.7974C7.48359 12.7974 5.22902 10.6788 5.22902 8.03499C5.22902 5.39123 7.48359 3.27258 10.2947 3.27258C13.1068 3.27258 15.3603 5.39123 15.3603 8.03499ZM2.63911 18.1899C2.63911 15.7426 6.1657 15.1303 10.2947 15.1303C14.4461 15.1303 17.9502 15.7637 17.9502 18.2129C17.9502 20.6603 14.4236 21.2726 10.2947 21.2726C6.14328 21.2726 2.63911 20.6392 2.63911 18.1899ZM17.4031 8.12133C17.4031 9.46765 16.973 10.7239 16.2187 11.7674C16.1402 11.8747 16.2096 12.0194 16.3461 12.0424C16.5357 12.0721 16.7304 12.0903 16.9291 12.0942C18.9065 12.143 20.681 10.9462 21.1712 9.14377C21.898 6.46934 19.7657 4.06801 17.0494 4.06801C16.7549 4.06801 16.4725 4.09676 16.1973 4.14946C16.1596 4.15713 16.1188 4.17438 16.0985 4.20504C16.072 4.24433 16.0913 4.29511 16.1178 4.32865C16.9342 5.40475 17.4031 6.71465 17.4031 8.12133ZM20.6779 13.9749C22.007 14.2192 22.8805 14.7166 23.2424 15.4419C23.5491 16.036 23.5491 16.726 23.2424 17.3201C22.6889 18.4431 20.9032 18.8044 20.2091 18.8973C20.0654 18.9165 19.9502 18.8015 19.9655 18.6654C20.3202 15.5531 17.4999 14.0774 16.7701 13.7382C16.7396 13.7219 16.7324 13.6989 16.7355 13.6836C16.7375 13.674 16.7508 13.6587 16.7742 13.6558C18.353 13.627 20.0511 13.8311 20.6779 13.9749Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c2c7b01bf1733e61885a61e7befdaa96.svg";
export { ForwardRef as ReactComponent };